import { render, staticRenderFns } from "./selector.vue?vue&type=template&id=06b8c794&scoped=true"
import script from "./selector.vue?vue&type=script&lang=js"
export * from "./selector.vue?vue&type=script&lang=js"
import style0 from "./selector.vue?vue&type=style&index=0&id=06b8c794&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b8c794",
  null
  
)

export default component.exports